import { Grid, ListSubheader, MenuItem, TextField } from '@mui/material'
import React from 'react'
import StatesAndProvinces from '../../shared/classes/StatesAndProvinces'

export default function AddressForm(props) {
    const { defaults, excludes = {}, onInput, onSubmit, disabled, submitButton, innerRef, ...otherProps } = props

    return (
        <form {...otherProps} ref={innerRef} onSubmit={onSubmit}>
            <Grid container spacing={2}>
                {!excludes.name &&
                    <Grid item xs={10}>
                        <TextField
                            variant="standard"
                            id="name"
                            name="name"
                            label="Name"
                            defaultValue={defaults.name || ''}
                            autoComplete="name"
                            required
                            fullWidth
                            disabled={disabled}
                            onInput={onInput}
                        />
                    </Grid>
                }
                {!excludes.email &&
                    <Grid item xs={10}>
                        <TextField
                            variant="standard"
                            id="email"
                            name="email"
                            defaultValue={defaults.email || ''}
                            label="Email Address"
                            type="email"
                            inputProps={{
                                // default pattern doesn't require .tld
                                pattern: "[a-z0-9._%+\\-]+@[a-z0-9.\\-]+\\.[a-z]{2,4}$"
                            }}
                            autoComplete="email"
                            required
                            fullWidth
                            disabled={disabled}
                            onInput={event => {
                                event.target.setCustomValidity('')

                                // set custom validity message
                                if (!event.target.validity.valid && !event.target.validity.valueMissing) {
                                    event.target.setCustomValidity('Invalid email address')
                                }

                                onInput && onInput(event)
                            }}
                        />
                    </Grid>
                }
                {!excludes.phone &&
                    <Grid item xs={10}>
                        <TextField
                            variant="standard"
                            id="phone"
                            name="phone"
                            defaultValue={defaults.phone || ''}
                            label="Phone/Mobile Number"
                            type="tel"
                            autoComplete="mobile"
                            required
                            fullWidth
                            disabled={disabled}
                            inputProps={{
                                inputMode: "numeric",
                                pattern: "\\d{10}",
                                minLength: 10,
                                maxLength: 10,
                            }}
                            onInput={event => {
                                event.target.setCustomValidity('')

                                // set custom validity message
                                if (!event.target.validity.valid && !event.target.validity.valueMissing) {
                                    event.target.setCustomValidity('Phone numbers must be in the format 1231231234')
                                }

                                onInput && onInput(event)
                            }}
                        />
                    </Grid>
                }
                {!excludes.street1 &&
                    <Grid item xs={10}>
                        <TextField
                            variant="standard"
                            id="street1"
                            name="street1"
                            inputProps={{ maxLength: 60 }}
                            defaultValue={defaults.street1 || ''}
                            label="Address Line 1"
                            autoComplete="street1"
                            required
                            fullWidth
                            disabled={disabled}
                            onInput={onInput}
                        />
                    </Grid>
                }
                {!excludes.street2 &&
                    <Grid item xs={10}>
                        <TextField
                            variant="standard"
                            id="street2"
                            name="street2"
                            inputProps={{ maxLength: 60 }}
                            defaultValue={defaults.street2 || ''}
                            label="Address Line 2"
                            autoComplete="street2"
                            fullWidth
                            disabled={disabled}
                            onInput={onInput}
                        />
                    </Grid>
                }
                {!excludes.city &&
                    <Grid item xs={10}>
                        <TextField
                            variant="standard"
                            id="city"
                            name="city"
                            defaultValue={defaults.city || ''}
                            label="City"
                            autoComplete="city"
                            required
                            fullWidth
                            disabled={disabled}
                            onInput={onInput}
                        />
                    </Grid>
                }
                {!excludes.state &&
                    <Grid item xs={10}>
                        <TextField
                            select={true}
                            variant="standard"
                            id="state"
                            name="state"
                            defaultValue={defaults.state || ''}
                            label="State / Province"
                            autoComplete="state"
                            required
                            fullWidth
                            disabled={disabled}
                            onInput={onInput}
                        >
                            <ListSubheader>USA</ListSubheader>
                            {Object.keys(StatesAndProvinces.usNames).map(abbrev => (
                                <MenuItem key={abbrev} value={abbrev}>{StatesAndProvinces.usNames[abbrev]}</MenuItem>
                            ))}
                            <ListSubheader>Canada</ListSubheader>
                            {Object.keys(StatesAndProvinces.caNames).map(abbrev => (
                                <MenuItem key={abbrev} value={abbrev}>{StatesAndProvinces.caNames[abbrev]}</MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                }
                {!excludes.zip &&
                    <Grid item xs={10}>
                        <TextField
                            variant="standard"
                            id="zip"
                            name="zip"
                            defaultValue={defaults.zip || ''}
                            label="Zip / Postal Code"
                            autoComplete="zip"
                            required
                            fullWidth
                            disabled={disabled}
                            inputProps={{
                                pattern: "(^\\d{5}(-\\d{4})?$)|(^[A-Za-z]\\d[A-Za-z] \\d[A-Za-z]\\d$)",
                            }}
                            onInput={event => {
                                event.target.setCustomValidity('')

                                // set custom validity message
                                if (!event.target.validity.valid && !event.target.validity.valueMissing) {
                                    event.target.setCustomValidity('Zip / Postal Codes must be in the format 12345, 12345-6789, or A1B 2C3.')
                                }

                                onInput && onInput(event)
                            }}
                        />
                    </Grid>
                }
            </Grid>
            {submitButton}
        </form>
    )
}
